import type { EligibilityMeta } from "@/sales-tools";

export const defaultEligibilityMeta: EligibilityMeta = Object.freeze({
    mdnLookupResult: {
        hasReachedMaxMdnLookups: false,
        previousHashedMdnLookups: [],
    },
});

export function normalizeEligibilityMeta(meta: EligibilityMeta | Partial<EligibilityMeta>): EligibilityMeta {
    const incoming: Partial<EligibilityMeta> = meta ?? {};
    const incomingMdnLookupResult = incoming.mdnLookupResult ?? defaultEligibilityMeta.mdnLookupResult;

    return {
        ...defaultEligibilityMeta,
        ...incoming,
        mdnLookupResult: {
            ...defaultEligibilityMeta.mdnLookupResult,
            ...incomingMdnLookupResult,
            previousHashedMdnLookups: Array.isArray(incomingMdnLookupResult.previousHashedMdnLookups)
                ? incomingMdnLookupResult.previousHashedMdnLookups
                : [],
        },
    };
}
